import { render, staticRenderFns } from "./GenerateFeedback.vue?vue&type=template&id=5389c452&scoped=true"
import script from "./GenerateFeedback.vue?vue&type=script&lang=ts"
export * from "./GenerateFeedback.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5389c452",
  null
  
)

export default component.exports